import { ReactNode } from "react";
import { ItemWithMetaData } from "../api/Items";
import ProfileRowConfirm from "./ProfileRowConfirm";

type Props = {
  profileList: ItemWithMetaData[];
  tabColor?: string;
  onDelete?: (itemUUID: string) => void;
  className?: string;
  children?: ReactNode;
  isManualAdd?: boolean;
  isReadOnly?: boolean;
  isSidebar?: boolean;
  showAddedBy?: boolean;
};

const ProfileDisplay = ({
  profileList,
  tabColor,
  onDelete,
  className,
  children,
  isManualAdd,
  isReadOnly,
  isSidebar,
  showAddedBy,
}: Props) => {
  return (
    <div className="border-black">
      {profileList &&
        profileList.map((item: ItemWithMetaData) => (
          <ProfileRowConfirm
            item={item}
            key={item.item.external_id}
            tabColor={tabColor}
            onDelete={onDelete}
            className={className}
            children={children}
            isManualAdd={isManualAdd}
            isReadOnly={isReadOnly}
            isSidebar={isSidebar}
            showAddedBy={showAddedBy}
          />
        ))}
    </div>
  );
};

export default ProfileDisplay;
